"use strict";
// From 'The Rule of Phocus':
// 4. Some states only allow focus among a subset of all focusable elements (modals, menus)
//     4.1. This subset is always contained in exactly one branch of the element tree
//
Object.defineProperty(exports, "__esModule", { value: true });
var ConstrainFocus = /** @class */ (function () {
    function ConstrainFocus() {
        var _this = this;
        this.stack = [];
        this.handler = function (e) {
            if (_this.noConstraints())
                return;
            var root = _this.currentRoot();
            if (!root)
                return;
            if (!e.relatedTarget)
                return;
            if (!root.contains(e.relatedTarget)) {
                _this.refocus(root, e.target);
            }
        };
    }
    ConstrainFocus.prototype.start = function () {
        document.addEventListener("blur", this.handler, true);
    };
    ConstrainFocus.prototype.stop = function () {
        document.removeEventListener("blur", this.handler, true);
    };
    ConstrainFocus.prototype.refocus = function (root, target) {
        if (root.contains(target)) {
            target.focus();
        }
        else {
            var focusable = root.querySelector("button, input, textarea, a, [tabindex='0']");
            if (focusable) {
                focusable.focus();
            }
            else {
                root.focus();
            }
        }
    };
    ConstrainFocus.prototype.focusable = function (element) {
        var root = this.currentRoot();
        return this.noConstraints() || (root && root.contains(element));
    };
    ConstrainFocus.prototype.currentRoot = function () {
        return this.stack[0] && this.stack[0].constraint();
    };
    ConstrainFocus.prototype.pushConstraint = function (root) {
        this.stack.unshift({
            constraint: root,
            previousFocus: document.activeElement
        });
        var rootE = this.currentRoot();
        var focus = document.activeElement;
        if (!rootE || !focus)
            return;
        this.refocus(rootE, focus);
    };
    ConstrainFocus.prototype.popConstraint = function () {
        var pop = this.stack.shift();
        if (!pop || !pop.previousFocus || !(pop.previousFocus instanceof HTMLElement))
            return;
        pop.previousFocus.focus();
    };
    ConstrainFocus.prototype.noConstraints = function () {
        return this.stack.length == 0;
    };
    return ConstrainFocus;
}());
exports.ConstrainFocus = ConstrainFocus;
exports.ConstrainFocusService = new ConstrainFocus();
//# sourceMappingURL=constrain-focus.js.map